import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultNurseUsersPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultNurseUsersFilter = {
	$skip: defaultNurseUsersPagination.$skip,
	$limit: defaultNurseUsersPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		nurseUsers: [],
		nurseUsersFilter: defaultNurseUsersFilter,
		nurseUsersPagination: defaultNurseUsersPagination,
	},
	getters: {
		nurseUsersPage: (state) => {
			const { $limit, $skip } = state.nurseUsersPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_NURSE_USERS: (state, nurseUsers) => { state.nurseUsers = nurseUsers; },
		SET_NURSE_USERS_PAGINATION: (state, data) => { state.nurseUsersPagination = { ...state.nurseUsersPagination, ...data }; },
		SET_NURSE_USERS_FILTER: (state, filter) => { state.nurseUsersFilter = { ...state.nurseUsersFilter, ...filter }; },
		SET_DEFAULT_NURSE_USERS_FILTER: (state, filter) => { state.nurseUsersFilter = { ...filter, ...defaultNurseUsersFilter }; },
	},
	actions: {
		setNurseUsersFilter: ({ commit }, filter) => {
			commit('SET_NURSE_USERS_FILTER', filter);
		},
		setDefaultNurseUsersFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_NURSE_USERS_FILTER', filter);
		},
		setNurseUsersPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.nurseUsersPagination.$limit;
			commit('SET_NURSE_USERS_PAGINATION', { $skip });
			commit('SET_NURSE_USERS_FILTER', { $skip });
		},
		getNurseStaffs: async({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/get-nurse-users').find({
				query: {
					fields: ['blockedUsers', 'optimaStaffNumber'],
					$getNurseUser: true,
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_NURSE_USERS', results.data);
			const totalCount = results.total;
			commit('SET_NURSE_USERS_PAGINATION', { total: totalCount });
			return results.data;
		},
		getNurseDeletedStaffs: async({ commit, rootGetters }, filter) => {
			const url = '/api/v3/users'; // shift manager
			const results = await feathersClient.service('/api/v3/users').find({
				query: { $getUsersOfTrust: true, ...filter, $sort: { firstname: 1 } },
			});
			commit('SET_NURSE_USERS', results.data);
			const totalCount = results.total;
			commit('SET_NURSE_USERS_PAGINATION', { total: totalCount });
			return results.data;
		},
		getRejectedUser: async({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/get-nurse-users').find({
				query: {
					$getRejectedUsers: true,
					$role: rootGetters.currentUserRole,
					...filter,
					$sort: { firstname: 1 },
				},

			});
			commit('SET_NURSE_USERS', results.data);
			const totalCount = results.total;
			commit('SET_NURSE_USERS_PAGINATION', { total: totalCount });
			return results.data;
		},
		getUserPermissionsOfTrust: async ({ rootGetters }, query) => {
			const url = '/api/v3/user-permissions-of-trust'; // trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...query } });
			return results;
		},
		getSelectedUserById: async (context, id) => {
			const url = '/api/v3/users/';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		getUserApprovedLevelsHierarchy: async({ rootGetters }) => {
			const results = await feathersClient.service('/api/v3/user-roles').find({
				query: {
					$getUserAccessHierarchy: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		getBlockingReasons: async ({ rootGetters }) => {
			const results = await feathersClient.service('/api/v3/blocked-users-reasons').find({

				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
				},
			});
			return results;
		},
		blockStaff: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/blocked-users').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		unblockStaff: async({ rootGetters }, data) => {
			const id = data.id;
			delete data.id;
			const results = await feathersClient.service('/api/v3/blocked-users').patch(id, data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		endorseUserSkill: async({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		setNewPasswordByAdmin:async({rootGetters},data) => {
			const results = await feathersClient.service('/api/v3/reset-password-by-admins').create(data, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		}
	},
};
